import React from 'react';
import TextField from 'components/FormElements/AppTextInput';
import CkEditor from 'components/CkEditor';
import DropzoneComponent from 'components/Dropzone';
import FieldRow from 'components/FormElements/FieldRow';
import { InputAdornment } from '@mui/material';

type Props = any; //TODO: define props

const NonVctFields: React.FC<Props> = ({
  values,
  setValues,
  handleChangeLogo,
  errorText,
  classes,
  duplicateCompanyWarning,
  disabled = false,
}) => (
  <>
    <FieldRow title="Trading name*" centerTitle>
      <TextField
        required
        name="tradingName"
        placeholder="Enter trading name, e.g. Acme"
        fullWidth
        disabled={disabled}
        onChange={(event) =>
          setValues({
            ...values,
            tradingName: event.target.value,
          })
        }
        value={values.tradingName}
        error={!!errorText.tradingName}
        helperText={errorText.tradingName}
      />
    </FieldRow>
    <FieldRow title="Full legal name*" centerTitle>
      <TextField
        required
        name="legalName"
        placeholder="Enter legal name, e.g. Acme Software Limited"
        fullWidth
        disabled={disabled}
        onChange={(event) =>
          setValues({ ...values, legalName: event.target.value })
        }
        value={values.legalName}
        error={!!errorText.legalName}
        helperText={errorText.legalName}
      />
      {duplicateCompanyWarning && (
        <p className={classes.warningCk}>{duplicateCompanyWarning}</p>
      )}
    </FieldRow>
    <FieldRow title="URL" centerTitle>
      <TextField
        name="url"
        placeholder="Enter URL"
        fullWidth
        disabled={disabled}
        onChange={(event) => setValues({ ...values, url: event.target.value })}
        value={values.url}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">https://</InputAdornment>
          ),
        }}
      />
    </FieldRow>
    <FieldRow title="Twitter/X URL" centerTitle>
      <TextField
        name="twitterUrl"
        placeholder="Enter Twitter/X URL"
        fullWidth
        disabled={disabled}
        onChange={(event) =>
          setValues({ ...values, twitterUrl: event.target.value })
        }
        value={values.twitterUrl}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">https://</InputAdornment>
          ),
        }}
      />
    </FieldRow>
    <FieldRow title="LinkedIn URL" centerTitle>
      <TextField
        name="linkedinUrl"
        placeholder="Enter LinkedIn URL"
        fullWidth
        disabled={disabled}
        onChange={(event) =>
          setValues({
            ...values,
            linkedinUrl: event.target.value,
          })
        }
        value={values.linkedinUrl}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">https://</InputAdornment>
          ),
        }}
      />
    </FieldRow>
    <FieldRow title="Companies House number" centerTitle>
      <TextField
        name="companiesHouseNumber"
        placeholder="Enter Companies House Number"
        fullWidth
        disabled={disabled}
        onChange={(event) =>
          setValues({
            ...values,
            companiesHouseNumber: event.target.value,
          })
        }
        value={values.companiesHouseNumber}
        error={!!errorText.companiesHouseNumber}
        helperText={errorText.companiesHouseNumber}
      />
    </FieldRow>
    <FieldRow title="Description*" topTitle>
      <CkEditor
        placeholder="Enter a description of the company in approximately 30-40+ words"
        disabled={disabled}
        onChange={(value) => {
          setValues({
            ...values,
            description: value,
          });
        }}
        value={values.description}
      />
      <p className={classes.errorCk}>{errorText.description}</p>
    </FieldRow>
    <FieldRow
      title={'Logo'}
      informationText={'(Square, no transparent background, .jpg or .png)'}
    >
      <DropzoneComponent
        name="companyLogo"
        disabled={disabled}
        defaultAcceptGroup="images"
        files={
          values?.companyLogo
            ? [{ preview: values?.previewCompanyLogo ?? '', fileName: '' }]
            : []
        }
        onRemove={() =>
          setValues({ ...values, previewCompanyLogo: null, companyLogo: null })
        }
        onDropFile={(files) => handleChangeLogo(files)}
      />
    </FieldRow>
  </>
);

export default NonVctFields;
